import {QueryKey, useQuery, useQueryClient} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';

interface Props {
    enabled: boolean;
    globalVersionId?: number;
}

const NODE_TYPES_LIMIT = 100;

function getNodeTypesRequest(props: Props) {
    return apiClient.get<string[]>({
        path: 'autocomplete-service/api/autocomplete/suggestions/node-types',
        query: {'global-version': props.globalVersionId, limit: NODE_TYPES_LIMIT}
    });
}

export function useNodeTypesQuery(props: Props) {
    return useQuery({
        queryKey: ['autocomplete-node-types', props.globalVersionId || 'no-gv'],
        queryFn: () => getNodeTypesRequest(props),
        enabled: props.enabled
    });
}

export function useNodeTypesQueryCache(props: Props) {
    const queryClient = useQueryClient();
    const key: QueryKey = ['autocomplete-node-types', props.globalVersionId || 'no-gv'];

    const invalidate = () => {
        return queryClient.invalidateQueries({queryKey: key});
    };

    return {
        invalidate
    };
}
